// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from "./client";
import type {
  AcceptSpotShareData,
  AcceptSpotShareErrors,
  AcceptSpotShareResponses,
  AcceptUserInviteData,
  AcceptUserInviteErrors,
  AcceptUserInviteResponses,
  AccessCodeSeriesSetSitesData,
  AccessCodeSeriesSetSitesErrors,
  AccessCodeSeriesSetSitesResponses,
  ActuateDeviceData,
  ActuateDeviceErrors,
  ActuateDeviceResponses,
  AddSpotTagsData,
  AddSpotTagsErrors,
  AddSpotTagsResponses,
  AdminSyncFinnProductsData,
  AdminSyncFinnProductsErrors,
  AdminSyncFinnProductsResponses,
  ApplicantSetDebtorData,
  ApplicantSetDebtorErrors,
  ApplicantSetDebtorResponses,
  AppSitesData,
  AppSitesErrors,
  AppSitesResponses,
  BatchCreateSpotsData,
  BatchCreateSpotsErrors,
  BatchCreateSpotsResponses,
  BatchDeleteSpotsData,
  BatchDeleteSpotsErrors,
  BatchDeleteSpotsResponses,
  BatchUpdateSpotsData,
  BatchUpdateSpotsErrors,
  BatchUpdateSpotsResponses,
  BulkCreateAccessCodesData,
  BulkCreateAccessCodesErrors,
  BulkCreateAccessCodesResponses,
  BulkDeleteAccessCodesData,
  BulkDeleteAccessCodesErrors,
  BulkDeleteAccessCodesResponses,
  BulkUpdateAccessCodesData,
  BulkUpdateAccessCodesErrors,
  BulkUpdateAccessCodesResponses,
  CalculateClassificationCountsData,
  CalculateClassificationCountsErrors,
  CalculateClassificationCountsResponses,
  CalculateTagTenanciesData,
  CalculateTagTenanciesErrors,
  CalculateTagTenanciesResponses,
  CancelLoginData,
  CancelLoginResponses,
  ClearClassificationCountsData,
  ClearClassificationCountsErrors,
  ClearClassificationCountsResponses,
  CreateAccessCodeSeriesData,
  CreateAccessCodeSeriesErrors,
  CreateAccessCodeSeriesResponses,
  CreateAgreementData,
  CreateAgreementErrors,
  CreateAgreementResponses,
  CreateDeviceData,
  CreateDeviceErrors,
  CreateDeviceResponses,
  CreateEntranceData,
  CreateEntranceErrors,
  CreateEntranceResponses,
  CreatePermitData,
  CreatePermitErrors,
  CreatePermitResponses,
  CreateSpotGroupData,
  CreateSpotGroupErrors,
  CreateSpotGroupResponses,
  CreateSpotShareData,
  CreateSpotShareErrors,
  CreateSpotShareResponses,
  CreateTagData,
  CreateTagErrors,
  CreateTagResponses,
  DebtorAddUserData,
  DebtorAddUserErrors,
  DebtorAddUserResponses,
  DebtorBatchDeleteData,
  DebtorBatchDeleteErrors,
  DebtorBatchDeleteResponses,
  DebtorCreateData,
  DebtorCreateErrors,
  DebtorCreateResponses,
  DebtorDeleteCardData,
  DebtorDeleteCardErrors,
  DebtorDeleteCardResponses,
  DebtorDeleteData,
  DebtorDeleteErrors,
  DebtorDeleteResponses,
  DebtorFinalizeCardSetupData,
  DebtorFinalizeCardSetupErrors,
  DebtorFinalizeCardSetupResponses,
  DebtorGetAgreementsData,
  DebtorGetAgreementsErrors,
  DebtorGetAgreementsResponses,
  DebtorGetApplicantsData,
  DebtorGetApplicantsErrors,
  DebtorGetApplicantsResponses,
  DebtorGetCardsData,
  DebtorGetCardsErrors,
  DebtorGetCardsResponses,
  DebtorGetData,
  DebtorGetDeliveryMethodData,
  DebtorGetDeliveryMethodErrors,
  DebtorGetDeliveryMethodResponses,
  DebtorGetErrors,
  DebtorGetInvoicePdfData,
  DebtorGetInvoicePdfErrors,
  DebtorGetInvoicePdfResponses,
  DebtorGetInvoicesData,
  DebtorGetInvoicesErrors,
  DebtorGetInvoicesResponses,
  DebtorGetPaymentMethodData,
  DebtorGetPaymentMethodErrors,
  DebtorGetPaymentMethodResponses,
  DebtorGetResponses,
  DebtorGetUsersData,
  DebtorGetUsersErrors,
  DebtorGetUsersResponses,
  DebtorListPaymentsData,
  DebtorListPaymentsErrors,
  DebtorListPaymentsResponses,
  DebtorPutData,
  DebtorPutErrors,
  DebtorPutResponses,
  DebtorRefundPaymentData,
  DebtorRefundPaymentErrors,
  DebtorRefundPaymentResponses,
  DebtorRemoveUsersData,
  DebtorRemoveUsersErrors,
  DebtorRemoveUsersResponses,
  DebtorRequestPaymentCardData,
  DebtorRequestPaymentCardErrors,
  DebtorRequestPaymentCardResponses,
  DebtorSearchData,
  DebtorSearchErrors,
  DebtorSearchResponses,
  DebtorSendPaymentReceiptData,
  DebtorSendPaymentReceiptErrors,
  DebtorSendPaymentReceiptResponses,
  DebtorSetDefaultCardData,
  DebtorSetDefaultCardErrors,
  DebtorSetDefaultCardResponses,
  DebtorSetDeliveryMethodData,
  DebtorSetDeliveryMethodErrors,
  DebtorSetDeliveryMethodResponses,
  DebtorSetPaymentMethodData,
  DebtorSetPaymentMethodErrors,
  DebtorSetPaymentMethodResponses,
  DebtorSetupCardData,
  DebtorSetupCardErrors,
  DebtorSetupCardResponses,
  DeleteAccessCodeSeriesData,
  DeleteAccessCodeSeriesErrors,
  DeleteAccessCodeSeriesResponses,
  DeleteAgreementsData,
  DeleteAgreementsErrors,
  DeleteAgreementsResponses,
  DeleteDevicesData,
  DeleteDevicesErrors,
  DeleteDevicesResponses,
  DeleteEntranceData,
  DeleteEntranceErrors,
  DeleteEntranceResponses,
  DeletePermitAgreementData,
  DeletePermitAgreementErrors,
  DeletePermitAgreementResponses,
  DeleteSpotShareData,
  DeleteSpotShareErrors,
  DeleteSpotShareResponses,
  DeleteSpotTagsData,
  DeleteSpotTagsErrors,
  DeleteSpotTagsResponses,
  DeleteTagData,
  DeleteTagErrors,
  DeleteTagResponses,
  DpliteUserCreateData,
  DpliteUserCreateErrors,
  DpliteUserCreateResponses,
  DpliteUserDeleteData,
  DpliteUserDeleteErrors,
  DpliteUserDeleteResponses,
  DpliteUserGetData,
  DpliteUserGetErrors,
  DpliteUserGetResponses,
  DpliteUserSearchData,
  DpliteUserSearchErrors,
  DpliteUserSearchResponses,
  DpliteUserSetAccessData,
  DpliteUserSetAccessErrors,
  DpliteUserSetAccessResponses,
  DpliteUserSetPasswordData,
  DpliteUserSetPasswordErrors,
  DpliteUserSetPasswordResponses,
  EndAgreementsData,
  EndAgreementsErrors,
  EndAgreementsResponses,
  GetAccessCodeSeriesData,
  GetAccessCodeSeriesErrors,
  GetAccessCodeSeriesResponses,
  GetAgreementAdditionalTermsData,
  GetAgreementAdditionalTermsErrors,
  GetAgreementAdditionalTermsResponses,
  GetAgreementData,
  GetAgreementErrors,
  GetAgreementFullTermsData,
  GetAgreementFullTermsErrors,
  GetAgreementFullTermsResponses,
  GetAgreementPdfData,
  GetAgreementPdfErrors,
  GetAgreementPdfResponses,
  GetAgreementResponses,
  GetAgreementSharesData,
  GetAgreementSharesErrors,
  GetAgreementSharesResponses,
  GetAllCreditorsData,
  GetAllCreditorsErrors,
  GetAllCreditorsResponses,
  GetCounterData,
  GetCounterResponses,
  GetCreditorData,
  GetCreditorErrors,
  GetCreditorResponses,
  GetDeviceData,
  GetDeviceErrors,
  GetDeviceResponses,
  GetEntranceData,
  GetEntranceDevicesData,
  GetEntranceDevicesErrors,
  GetEntranceDevicesResponses,
  GetEntranceErrors,
  GetEntranceResponses,
  GetEntranceTagsData,
  GetEntranceTagsErrors,
  GetEntranceTagsResponses,
  GetLoginStatusData,
  GetLoginStatusResponses,
  GetMyAgreementsData,
  GetMyAgreementsErrors,
  GetMyAgreementsResponses,
  GetMySitesData,
  GetMySitesErrors,
  GetMySitesResponses,
  GetSentEmailData,
  GetSentEmailErrors,
  GetSentEmailResponses,
  GetSiteSupportInfoData,
  GetSiteSupportInfoErrors,
  GetSiteSupportInfoResponses,
  GetSiteTermsData,
  GetSiteTermsErrors,
  GetSiteTermsResponses,
  GetSpotAgreementsData,
  GetSpotAgreementsErrors,
  GetSpotAgreementsResponses,
  GetSpotApplicantsData,
  GetSpotApplicantsErrors,
  GetSpotApplicantsResponses,
  GetSpotData,
  GetSpotErrors,
  GetSpotGroupData,
  GetSpotGroupErrors,
  GetSpotGroupResponses,
  GetSpotResponses,
  GetSpotShareData,
  GetSpotShareErrors,
  GetSpotShareResponses,
  GetSpotSharesData,
  GetSpotSharesErrors,
  GetSpotSharesResponses,
  GetSpotTagsData,
  GetSpotTagsErrors,
  GetSpotTagsResponses,
  GetTagData,
  GetTagEntrancesData,
  GetTagEntrancesErrors,
  GetTagEntrancesResponses,
  GetTagErrors,
  GetTagResponses,
  GetTagTermsData,
  GetTagTermsErrors,
  GetTagTermsResponses,
  ImportRollbackData,
  ImportRollbackErrors,
  ImportRollbackResponses,
  LoginStoreTestData,
  LoginStoreTestResponses,
  MasqueradeData,
  MasqueradeErrors,
  MasqueradeResponses,
  OfferAgreementData,
  OfferAgreementErrors,
  OfferAgreementResponses,
  Park46SearchDebtorsData,
  Park46SearchDebtorsErrors,
  Park46SearchDebtorsResponses,
  Park46SearchSitesData,
  Park46SearchSitesErrors,
  Park46SearchSitesResponses,
  PayPermitData,
  PayPermitErrors,
  PayPermitPeriodData,
  PayPermitPeriodErrors,
  PayPermitPeriodResponses,
  PayPermitResponses,
  PermitBulkDeleteGrantData,
  PermitBulkDeleteGrantErrors,
  PermitBulkDeleteGrantResponses,
  PermitCreateGrantData,
  PermitCreateGrantErrors,
  PermitCreateGrantResponses,
  PermitGetGrantData,
  PermitGetGrantErrors,
  PermitGetGrantResponses,
  PermitListSessionsData,
  PermitListSessionsErrors,
  PermitListSessionsResponses,
  PermitSessionStartData,
  PermitSessionStartErrors,
  PermitSessionStartResponses,
  PermitSessionStopData,
  PermitSessionStopErrors,
  PermitSessionStopResponses,
  PostAccessCodeSeriesConnectedSeriesData,
  PostAccessCodeSeriesConnectedSeriesErrors,
  PostAccessCodeSeriesConnectedSeriesResponses,
  PreApproveAgreementsData,
  PreApproveAgreementsErrors,
  PreApproveAgreementsResponses,
  PreviewPayPermitData,
  PreviewPayPermitErrors,
  PreviewPayPermitPeriodData,
  PreviewPayPermitPeriodErrors,
  PreviewPayPermitPeriodResponses,
  PreviewPayPermitResponses,
  ProductCreateData,
  ProductCreateErrors,
  ProductCreateResponses,
  ProductGetData,
  ProductGetErrors,
  ProductGetResponses,
  ProductPutData,
  ProductPutErrors,
  ProductPutResponses,
  ProductsDeleteData,
  ProductsDeleteErrors,
  ProductsDeleteResponses,
  ProductsSearchData,
  ProductsSearchErrors,
  ProductsSearchResponses,
  PublicDebtorAndCardsGetData,
  PublicDebtorAndCardsGetResponses,
  PublicDebtorFinalizeCardSetupData,
  PublicDebtorFinalizeCardSetupResponses,
  PublicDebtorSetupCardData,
  PublicDebtorSetupCardResponses,
  PublicSearchSpotClassesData,
  PublicSearchSpotClassesResponses,
  PublicSearchSpotsData,
  PublicSearchSpotsResponses,
  PublicSiteGetData,
  PublicSiteGetQueueData,
  PublicSiteGetQueueResponses,
  PublicSiteGetResponses,
  PublicSiteSearchData,
  PublicSiteSearchResponses,
  PublicSpotclassGetSpotsData,
  PublicSpotclassGetSpotsResponses,
  PutDeviceData,
  PutDeviceErrors,
  PutDeviceResponses,
  PutEntranceData,
  PutEntranceErrors,
  PutEntranceResponses,
  PutSpotData,
  PutSpotErrors,
  PutSpotResponses,
  PutTagData,
  PutTagErrors,
  PutTagResponses,
  QueueApplicantMatchingSpotsData,
  QueueApplicantMatchingSpotsErrors,
  QueueApplicantMatchingSpotsResponses,
  QueueApplicantsInfoRequestData,
  QueueApplicantsInfoRequestErrors,
  QueueApplicantsInfoRequestResponses,
  QueueBulkDeleteApplicantsData,
  QueueBulkDeleteApplicantsErrors,
  QueueBulkDeleteApplicantsResponses,
  QueueDeleteApplicantData,
  QueueDeleteApplicantErrors,
  QueueDeleteApplicantResponses,
  QueueGetApplicantData,
  QueueGetApplicantErrors,
  QueueGetApplicantResponses,
  QueueGetApplicantsData,
  QueueGetApplicantsErrors,
  QueueGetApplicantsResponses,
  QueueGetAvailabilityData,
  QueueGetAvailabilityErrors,
  QueueGetAvailabilityResponses,
  QueueGetData,
  QueueGetResponses,
  QueuePostApplicantData,
  QueuePostApplicantErrors,
  QueuePostApplicantResponses,
  QueuePutData,
  QueuePutErrors,
  QueuePutResponses,
  QueueSearchSpotsData,
  QueueSearchSpotsErrors,
  QueueSearchSpotsResponses,
  QueueStepCreateData,
  QueueStepCreateErrors,
  QueueStepCreateResponses,
  QueueStepDeleteData,
  QueueStepDeleteErrors,
  QueueStepDeleteResponses,
  QueueStepSetTagsData,
  QueueStepSetTagsErrors,
  QueueStepSetTagsResponses,
  QueueStepUpdateData,
  QueueStepUpdateErrors,
  QueueStepUpdateResponses,
  QueueUpdateApplicantData,
  QueueUpdateApplicantErrors,
  QueueUpdateApplicantResponses,
  RegisterFcmTokenData,
  RegisterFcmTokenErrors,
  RegisterFcmTokenResponses,
  ReplyToAgreementOfferData,
  ReplyToAgreementOfferErrors,
  ReplyToAgreementOfferResponses,
  ResendUserInviteData,
  ResendUserInviteErrors,
  ResendUserInviteResponses,
  ResetAgreementsToDraftData,
  ResetAgreementsToDraftErrors,
  ResetAgreementsToDraftResponses,
  SearchAccessCodesData,
  SearchAccessCodeSeriesData,
  SearchAccessCodeSeriesErrors,
  SearchAccessCodeSeriesResponses,
  SearchAccessCodesErrors,
  SearchAccessCodesResponses,
  SearchAgreementsData,
  SearchAgreementsErrors,
  SearchAgreementsResponses,
  SearchClientsData,
  SearchClientsErrors,
  SearchClientsResponses,
  SearchEntranceData,
  SearchEntranceErrors,
  SearchEntranceResponses,
  SearchGrantsData,
  SearchGrantsErrors,
  SearchGrantsResponses,
  SearchSentEmailsData,
  SearchSentEmailsErrors,
  SearchSentEmailsResponses,
  SearchSpotClassesData,
  SearchSpotClassesErrors,
  SearchSpotClassesResponses,
  SearchSpotsData,
  SearchSpotsErrors,
  SearchSpotSharesData,
  SearchSpotSharesErrors,
  SearchSpotSharesResponses,
  SearchSpotsResponses,
  SearchSystemClientsData,
  SearchSystemClientsErrors,
  SearchSystemClientsResponses,
  SearchSystemSitesData,
  SearchSystemSitesErrors,
  SearchSystemSitesResponses,
  SetAgreementAdditionalTermsData,
  SetAgreementAdditionalTermsErrors,
  SetAgreementAdditionalTermsResponses,
  SetAgreementPdfData,
  SetAgreementPdfErrors,
  SetAgreementPdfResponses,
  SetEntranceDevicesData,
  SetEntranceDevicesErrors,
  SetEntranceDevicesResponses,
  SetEntranceTagsData,
  SetEntranceTagsErrors,
  SetEntranceTagsResponses,
  SetSiteSupportInfoData,
  SetSiteSupportInfoErrors,
  SetSiteSupportInfoResponses,
  SetSiteTermsData,
  SetSiteTermsErrors,
  SetSiteTermsResponses,
  SetTagEntrancesData,
  SetTagEntrancesErrors,
  SetTagEntrancesResponses,
  SetTagTermsData,
  SetTagTermsErrors,
  SetTagTermsResponses,
  SiGetProductCommissionsData,
  SiGetProductCommissionsErrors,
  SiGetProductCommissionsResponses,
  SiPutProductCommissionData,
  SiPutProductCommissionErrors,
  SiPutProductCommissionResponses,
  SiteAgreementsImportData,
  SiteAgreementsImportErrors,
  SiteAgreementsImportResponses,
  SiteAreaGetData,
  SiteAreaGetErrors,
  SiteAreaGetResponses,
  SiteAreasCreateData,
  SiteAreasCreateErrors,
  SiteAreasCreateResponses,
  SiteAreasGetData,
  SiteAreasGetErrors,
  SiteAreasGetResponses,
  SiteAreasUpdateData,
  SiteAreasUpdateErrors,
  SiteAreasUpdateResponses,
  SiteConnectCreditorData,
  SiteConnectCreditorErrors,
  SiteConnectCreditorResponses,
  SiteConnectionsGetData,
  SiteConnectionsGetErrors,
  SiteConnectionsGetResponses,
  SiteConnectionsPutData,
  SiteConnectionsPutErrors,
  SiteConnectionsPutResponses,
  SiteCreateData,
  SiteCreateErrors,
  SiteCreateResponses,
  SiteDisconnectCreditorData,
  SiteDisconnectCreditorErrors,
  SiteDisconnectCreditorResponses,
  SiteGetAgreementSettingsData,
  SiteGetAgreementSettingsErrors,
  SiteGetAgreementSettingsResponses,
  SiteGetAllData,
  SiteGetAllErrors,
  SiteGetAllResponses,
  SiteGetData,
  SiteGetDevicesData,
  SiteGetDevicesErrors,
  SiteGetDevicesResponses,
  SiteGetErrors,
  SiteGetQueueData,
  SiteGetQueueErrors,
  SiteGetQueueResponses,
  SiteGetResponses,
  SiteGetSpotsData,
  SiteGetSpotsErrors,
  SiteGetSpotsResponses,
  SiteGetStatsData,
  SiteGetStatsErrors,
  SiteGetStatsResponses,
  SiteLenderInfoGetData,
  SiteLenderInfoGetErrors,
  SiteLenderInfoGetResponses,
  SiteLenderInfoPutData,
  SiteLenderInfoPutErrors,
  SiteLenderInfoPutResponses,
  SiteP46ImportData,
  SiteP46ImportErrors,
  SiteP46ImportResponses,
  SitePutData,
  SitePutErrors,
  SitePutResponses,
  SiteRentalInfoGetData,
  SiteRentalInfoGetErrors,
  SiteRentalInfoGetResponses,
  SiteRentalInfoPutData,
  SiteRentalInfoPutErrors,
  SiteRentalInfoPutResponses,
  SiteSearchData,
  SiteSearchErrors,
  SiteSearchResponses,
  SiteSetAgreementSettingsData,
  SiteSetAgreementSettingsErrors,
  SiteSetAgreementSettingsResponses,
  SiteTagsGetData,
  SiteTagsGetErrors,
  SiteTagsGetResponses,
  SpotclassGetSpotsData,
  SpotclassGetSpotsResponses,
  SpotsSetAreaData,
  SpotsSetAreaErrors,
  SpotsSetAreaResponses,
  StartLoginData,
  StartLoginResponses,
  StartMyPagesData,
  StartMyPagesErrors,
  StartMyPagesResponses,
  SysErrorData,
  SysErrorErrors,
  SysErrorResponses,
  SysSearchRebuildData,
  SysSearchRebuildErrors,
  SysSearchRebuildResponses,
  SysSyncBillectaData,
  SysSyncBillectaErrors,
  SysSyncBillectaResponses,
  SystemSearchPaymentsData,
  SystemSearchPaymentsErrors,
  SystemSearchPaymentsResponses,
  SysWarnData,
  SysWarnErrors,
  SysWarnResponses,
  UpdateAccessCodeSeriesData,
  UpdateAccessCodeSeriesErrors,
  UpdateAccessCodeSeriesResponses,
  UpdateAgreementData,
  UpdateAgreementErrors,
  UpdateAgreementResponses,
  UpdateCreditorData,
  UpdateCreditorErrors,
  UpdateCreditorResponses,
  UpdateGrantLicensePlateData,
  UpdateGrantLicensePlateErrors,
  UpdateGrantLicensePlateResponses,
  UpdateSpotShareData,
  UpdateSpotShareErrors,
  UpdateSpotShareResponses,
  ValidateAccessCodeData,
  ValidateAccessCodeResponses,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Sys Search Rebuild
 * Rebuilds the given search indexes
 */
export const sysSearchRebuild = <ThrowOnError extends boolean = false>(
  options: Options<SysSearchRebuildData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SysSearchRebuildResponses,
    SysSearchRebuildErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/admin/search/rebuild",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * adminSyncFinnProducts
 * syncs products and billecta products with Finn
 */
export const adminSyncFinnProducts = <ThrowOnError extends boolean = false>(
  options?: Options<AdminSyncFinnProductsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    AdminSyncFinnProductsResponses,
    AdminSyncFinnProductsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/admin/sync/finn/products",
    ...options,
  });
};

/**
 * Sys warn
 * Forces a warning message to be logged.
 */
export const sysWarn = <ThrowOnError extends boolean = false>(
  options: Options<SysWarnData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SysWarnResponses,
    SysWarnErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/admin/log/warning",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Sys error
 * Forces an error message to be logged.
 */
export const sysError = <ThrowOnError extends boolean = false>(
  options: Options<SysErrorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SysErrorResponses,
    SysErrorErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/admin/log/error",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * System masquerade
 * Masquerade as a specific user
 */
export const masquerade = <ThrowOnError extends boolean = false>(
  options: Options<MasqueradeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MasqueradeResponses,
    MasqueradeErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/masquerade",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * System sites search
 * Search system sites
 */
export const searchSystemSites = <ThrowOnError extends boolean = false>(
  options: Options<SearchSystemSitesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchSystemSitesResponses,
    SearchSystemSitesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/sites/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * System client search
 * Search system clients
 */
export const searchSystemClients = <ThrowOnError extends boolean = false>(
  options: Options<SearchSystemClientsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchSystemClientsResponses,
    SearchSystemClientsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/clients/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * System sync Billecta
 * System sync a Billecta target
 */
export const sysSyncBillecta = <ThrowOnError extends boolean = false>(
  options: Options<SysSyncBillectaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SysSyncBillectaResponses,
    SysSyncBillectaErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/sync/billecta",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Recalculate tag tenancy table
 * Recalculate tag tenancies and save to the table
 */
export const calculateTagTenancies = <ThrowOnError extends boolean = false>(
  options: Options<CalculateTagTenanciesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CalculateTagTenanciesResponses,
    CalculateTagTenanciesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/reports/tag_tenancies/calculate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Clear entries in the classification counts table
 * Clear entries in the classification counts table
 */
export const clearClassificationCounts = <ThrowOnError extends boolean = false>(
  options: Options<ClearClassificationCountsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    ClearClassificationCountsResponses,
    ClearClassificationCountsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/reports/classification_counts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Recalculate classification counts table
 * Recalculate classification counts and save to the table
 */
export const calculateClassificationCounts = <
  ThrowOnError extends boolean = false,
>(options: Options<CalculateClassificationCountsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<
    CalculateClassificationCountsResponses,
    CalculateClassificationCountsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/reports/classification_counts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get a sent email
 * Gets an email sent by the system
 */
export const getSentEmail = <ThrowOnError extends boolean = false>(
  options: Options<GetSentEmailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSentEmailResponses,
    GetSentEmailErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/emails/{id}",
    ...options,
  });
};

/**
 * Search sent emails
 * Searches emails sent by the system
 */
export const searchSentEmails = <ThrowOnError extends boolean = false>(
  options: Options<SearchSentEmailsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchSentEmailsResponses,
    SearchSentEmailsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/emails",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * System Search Payments
 * System Search payments
 */
export const systemSearchPayments = <ThrowOnError extends boolean = false>(
  options: Options<SystemSearchPaymentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SystemSearchPaymentsResponses,
    SystemSearchPaymentsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/system/payments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const loginStoreTest = <ThrowOnError extends boolean = false>(
  options: Options<LoginStoreTestData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    LoginStoreTestResponses,
    unknown,
    ThrowOnError
  >({
    url: "/login/store-test",
    ...options,
  });
};

export const startLogin = <ThrowOnError extends boolean = false>(
  options: Options<StartLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    StartLoginResponses,
    unknown,
    ThrowOnError
  >({
    url: "/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getLoginStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetLoginStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLoginStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/login/status/{id}",
    ...options,
  });
};

export const cancelLogin = <ThrowOnError extends boolean = false>(
  options: Options<CancelLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CancelLoginResponses,
    unknown,
    ThrowOnError
  >({
    url: "/login/cancel/{id}",
    ...options,
  });
};

/**
 * Get app data
 * Get data generally used by the app
 */
export const appSites = <ThrowOnError extends boolean = false>(
  options?: Options<AppSitesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AppSitesResponses,
    AppSitesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/app/sites",
    ...options,
  });
};

/**
 * Register token for push notifications
 */
export const registerFcmToken = <ThrowOnError extends boolean = false>(
  options: Options<RegisterFcmTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    RegisterFcmTokenResponses,
    RegisterFcmTokenErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/app/register-fcm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * MyPages Start
 */
export const startMyPages = <ThrowOnError extends boolean = false>(
  options?: Options<StartMyPagesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    StartMyPagesResponses,
    StartMyPagesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/mypages/start",
    ...options,
  });
};

/**
 * Accept user invite
 */
export const acceptUserInvite = <ThrowOnError extends boolean = false>(
  options: Options<AcceptUserInviteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AcceptUserInviteResponses,
    AcceptUserInviteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/mypages/accept-invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all agreements that belong to the debtors that are connected to the user
 */
export const getMyAgreements = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyAgreementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    GetMyAgreementsResponses,
    GetMyAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/mypages/agreements",
    ...options,
  });
};

/**
 * Get all sites that the user's debtors have access to.
 */
export const getMySites = <ThrowOnError extends boolean = false>(
  options?: Options<GetMySitesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    GetMySitesResponses,
    GetMySitesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/mypages/sites",
    ...options,
  });
};

/**
 * Site search
 * Paginated search of sites
 */
export const siteSearch = <ThrowOnError extends boolean = false>(
  options: Options<SiteSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SiteSearchResponses,
    SiteSearchErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site get all
 * Get all sites
 */
export const siteGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<SiteGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SiteGetAllResponses,
    SiteGetAllErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites",
    ...options,
  });
};

/**
 * Site create
 * Create a new site
 */
export const siteCreate = <ThrowOnError extends boolean = false>(
  options: Options<SiteCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SiteCreateResponses,
    SiteCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site get
 * Get a site by id
 */
export const siteGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteGetResponses,
    SiteGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}",
    ...options,
  });
};

/**
 * Site update
 * Update a site by id
 */
export const sitePut = <ThrowOnError extends boolean = false>(
  options: Options<SitePutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SitePutResponses,
    SitePutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site get Terms
 * Get the terms of a site
 */
export const getSiteTerms = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteTermsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteTermsResponses,
    GetSiteTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/terms",
    ...options,
  });
};

/**
 * Site set Terms
 * Set terms for a site
 */
export const setSiteTerms = <ThrowOnError extends boolean = false>(
  options: Options<SetSiteTermsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetSiteTermsResponses,
    SetSiteTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/terms",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site get SupportInfo
 * Get the support info for a site
 */
export const getSiteSupportInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteSupportInfoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteSupportInfoResponses,
    GetSiteSupportInfoErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/support_info",
    ...options,
  });
};

/**
 * Site set SupportInfo
 * Set the support info for a site
 */
export const setSiteSupportInfo = <ThrowOnError extends boolean = false>(
  options: Options<SetSiteSupportInfoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetSiteSupportInfoResponses,
    SetSiteSupportInfoErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/support_info",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Tags get for site
 * Get all tags used in a site
 */
export const siteTagsGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteTagsGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteTagsGetResponses,
    SiteTagsGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/tags",
    ...options,
  });
};

/**
 * Areas get for site
 * Get all areas in a site
 */
export const siteAreasGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteAreasGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteAreasGetResponses,
    SiteAreasGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/areas",
    ...options,
  });
};

/**
 * Areas create for site
 * Create an Area in site
 */
export const siteAreasCreate = <ThrowOnError extends boolean = false>(
  options: Options<SiteAreasCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SiteAreasCreateResponses,
    SiteAreasCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/areas",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get area for site
 * Get a details of a single area for site
 */
export const siteAreaGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteAreaGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteAreaGetResponses,
    SiteAreaGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{site_id}/areas/{area_id}",
    ...options,
  });
};

/**
 * Areas update
 * Update an area in a site
 */
export const siteAreasUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SiteAreasUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SiteAreasUpdateResponses,
    SiteAreasUpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{site_id}/areas/{area_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Connections get for a site
 * Get Connections for a site
 */
export const siteConnectionsGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteConnectionsGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteConnectionsGetResponses,
    SiteConnectionsGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/connections",
    ...options,
  });
};

/**
 * Connections put for a site
 * Update Connections for a site
 */
export const siteConnectionsPut = <ThrowOnError extends boolean = false>(
  options: Options<SiteConnectionsPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SiteConnectionsPutResponses,
    SiteConnectionsPutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/connections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site RentalInfo get
 * Get RentalInfo for Site
 */
export const siteRentalInfoGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteRentalInfoGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteRentalInfoGetResponses,
    SiteRentalInfoGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/rental_info",
    ...options,
  });
};

/**
 * Site RentalInfo update
 * Update RentalInfo for Site
 */
export const siteRentalInfoPut = <ThrowOnError extends boolean = false>(
  options: Options<SiteRentalInfoPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SiteRentalInfoPutResponses,
    SiteRentalInfoPutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/rental_info",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site LenderInfo get
 * Get LenderInfo for Site
 */
export const siteLenderInfoGet = <ThrowOnError extends boolean = false>(
  options: Options<SiteLenderInfoGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteLenderInfoGetResponses,
    SiteLenderInfoGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/lender_info",
    ...options,
  });
};

/**
 * Site LenderInfo update
 * Update LenderInfo for Site
 */
export const siteLenderInfoPut = <ThrowOnError extends boolean = false>(
  options: Options<SiteLenderInfoPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SiteLenderInfoPutResponses,
    SiteLenderInfoPutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/lender_info",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site get stats
 * Get overview stats
 */
export const siteGetStats = <ThrowOnError extends boolean = false>(
  options: Options<SiteGetStatsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteGetStatsResponses,
    SiteGetStatsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/stats",
    ...options,
  });
};

/**
 * Site AgreementSettings get
 * Get AgreementSettings for a site
 */
export const siteGetAgreementSettings = <ThrowOnError extends boolean = false>(
  options: Options<SiteGetAgreementSettingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteGetAgreementSettingsResponses,
    SiteGetAgreementSettingsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/agreement_settings",
    ...options,
  });
};

/**
 * Site AgreementSettings set
 * Set AgreementSettings for a site
 */
export const siteSetAgreementSettings = <ThrowOnError extends boolean = false>(
  options: Options<SiteSetAgreementSettingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SiteSetAgreementSettingsResponses,
    SiteSetAgreementSettingsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/agreement_settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Devices by site
 * Get all devices for a site
 */
export const siteGetDevices = <ThrowOnError extends boolean = false>(
  options: Options<SiteGetDevicesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteGetDevicesResponses,
    SiteGetDevicesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/devices",
    ...options,
  });
};

/**
 * Spots by site
 * Get all spots in a site
 */
export const siteGetSpots = <ThrowOnError extends boolean = false>(
  options: Options<SiteGetSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteGetSpotsResponses,
    SiteGetSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/spots",
    ...options,
  });
};

/**
 * Site get queue
 * Get sites Queue
 */
export const siteGetQueue = <ThrowOnError extends boolean = false>(
  options: Options<SiteGetQueueData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiteGetQueueResponses,
    SiteGetQueueErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/queue",
    ...options,
  });
};

/**
 * Site disconnect Creditor
 * Disconnect creditor from the given site
 */
export const siteDisconnectCreditor = <ThrowOnError extends boolean = false>(
  options: Options<SiteDisconnectCreditorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    SiteDisconnectCreditorResponses,
    SiteDisconnectCreditorErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/creditor",
    ...options,
  });
};

/**
 * Site connect Creditor
 * Connect a Creditor to the given site
 */
export const siteConnectCreditor = <ThrowOnError extends boolean = false>(
  options: Options<SiteConnectCreditorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SiteConnectCreditorResponses,
    SiteConnectCreditorErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/sites/{id}/creditor",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Public site search
 * Site search for the public, no jwt requried.
 */
export const publicSiteSearch = <ThrowOnError extends boolean = false>(
  options: Options<PublicSiteSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublicSiteSearchResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/store/sites/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Public site get
 * Get a site by id, no jwt required. Only public sites will be returned.
 */
export const publicSiteGet = <ThrowOnError extends boolean = false>(
  options: Options<PublicSiteGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PublicSiteGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/store/sites/{id}",
    ...options,
  });
};

/**
 * Public site get queue
 * Get sites Queue without jwt
 */
export const publicSiteGetQueue = <ThrowOnError extends boolean = false>(
  options: Options<PublicSiteGetQueueData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PublicSiteGetQueueResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/store/sites/{id}/queue",
    ...options,
  });
};

/**
 * Public search for spot classes
 */
export const publicSearchSpotClasses = <ThrowOnError extends boolean = false>(
  options: Options<PublicSearchSpotClassesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublicSearchSpotClassesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/store/spot-classes/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Search for spot classes
 */
export const publicSpotclassGetSpots = <ThrowOnError extends boolean = false>(
  options: Options<PublicSpotclassGetSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublicSpotclassGetSpotsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/store/spot-classes/spots",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Public Spots search
 * Public spot search, no jwt required.
 */
export const publicSearchSpots = <ThrowOnError extends boolean = false>(
  options: Options<PublicSearchSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublicSearchSpotsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/store/spots/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get
 * Get a debtor by id
 */
export const publicDebtorAndCardsGet = <ThrowOnError extends boolean = false>(
  options: Options<PublicDebtorAndCardsGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublicDebtorAndCardsGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/debtor/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor setup new Payment card
 * Setup a new card for a Debtor
 */
export const publicDebtorSetupCard = <ThrowOnError extends boolean = false>(
  options: Options<PublicDebtorSetupCardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublicDebtorSetupCardResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/debtor/{id}/cards",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor finalize card setup
 * Finalize card setup for a debtor
 */
export const publicDebtorFinalizeCardSetup = <
  ThrowOnError extends boolean = false,
>(options: Options<PublicDebtorFinalizeCardSetupData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<
    PublicDebtorFinalizeCardSetupResponses,
    unknown,
    ThrowOnError
  >({
    url: "/public/debtor/{debtorId}/cards/setup/{setupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Site p46Import
 * import a site from park46
 */
export const siteP46Import = <ThrowOnError extends boolean = false>(
  options: Options<SiteP46ImportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SiteP46ImportResponses,
    SiteP46ImportErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/import/p46",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Import agreements in csv format
 * Import agreements for a site
 */
export const siteAgreementsImport = <ThrowOnError extends boolean = false>(
  options: Options<SiteAgreementsImportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SiteAgreementsImportResponses,
    SiteAgreementsImportErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/import/site_agreements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/octet-stream",
      ...options.headers,
    },
  });
};

/**
 * Rollback of imports
 * Rollback a previous import
 */
export const importRollback = <ThrowOnError extends boolean = false>(
  options: Options<ImportRollbackData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ImportRollbackResponses,
    ImportRollbackErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/import/rollback/{importId}",
    ...options,
  });
};

export const searchClients = <ThrowOnError extends boolean = false>(
  options: Options<SearchClientsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchClientsResponses,
    SearchClientsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/clients",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spot get
 * Get a single spot
 */
export const getSpot = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotResponses,
    GetSpotErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}",
    ...options,
  });
};

/**
 * Spot update
 * Update a spot
 */
export const putSpot = <ThrowOnError extends boolean = false>(
  options: Options<PutSpotData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    PutSpotResponses,
    PutSpotErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spot get agreements
 * Get all agreements for this spot
 */
export const getSpotAgreements = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotAgreementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotAgreementsResponses,
    GetSpotAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/agreements",
    ...options,
  });
};

/**
 * Validate access code for the spot
 */
export const validateAccessCode = <ThrowOnError extends boolean = false>(
  options: Options<ValidateAccessCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ValidateAccessCodeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/spots/{id}/validate_acces_code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spot get shares
 * Get all shares for this spot
 */
export const getSpotShares = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotSharesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotSharesResponses,
    GetSpotSharesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/shares",
    ...options,
  });
};

/**
 * Spot group get
 * Get all spots grouped in this spot
 */
export const getSpotGroup = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotGroupResponses,
    GetSpotGroupErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/group",
    ...options,
  });
};

/**
 * Spot delete tags
 * Deletes tags from a spot
 */
export const deleteSpotTags = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSpotTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteSpotTagsResponses,
    DeleteSpotTagsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spot get tags
 * Get tags of a spot
 */
export const getSpotTags = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotTagsResponses,
    GetSpotTagsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/tags",
    ...options,
  });
};

/**
 * Spot add tags
 * Adds tags to a spot
 */
export const addSpotTags = <ThrowOnError extends boolean = false>(
  options: Options<AddSpotTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    AddSpotTagsResponses,
    AddSpotTagsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spot get applicants
 * Get any applicants matching this spot
 */
export const getSpotApplicants = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotApplicantsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotApplicantsResponses,
    GetSpotApplicantsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/{id}/applicants",
    ...options,
  });
};

/**
 * Spots search
 * Paginated search of spots
 */
export const searchSpots = <ThrowOnError extends boolean = false>(
  options: Options<SearchSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchSpotsResponses,
    SearchSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spots batch delete
 * Delete multiple spots
 */
export const batchDeleteSpots = <ThrowOnError extends boolean = false>(
  options: Options<BatchDeleteSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    BatchDeleteSpotsResponses,
    BatchDeleteSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spots batch create
 * Create multiple spots
 */
export const batchCreateSpots = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BatchCreateSpotsResponses,
    BatchCreateSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spots batch update
 * Update multiple spots
 */
export const batchUpdateSpots = <ThrowOnError extends boolean = false>(
  options: Options<BatchUpdateSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    BatchUpdateSpotsResponses,
    BatchUpdateSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Spots group
 * Group multiple spots
 */
export const createSpotGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateSpotGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateSpotGroupResponses,
    CreateSpotGroupErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/group",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Areas set for spots
 * Set area for many spots
 */
export const spotsSetArea = <ThrowOnError extends boolean = false>(
  options: Options<SpotsSetAreaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SpotsSetAreaResponses,
    SpotsSetAreaErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spots/area",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Tag create
 * Create a new tag
 */
export const createTag = <ThrowOnError extends boolean = false>(
  options: Options<CreateTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateTagResponses,
    CreateTagErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Tag delete
 * Deletes a tag
 */
export const deleteTag = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteTagResponses,
    DeleteTagErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}",
    ...options,
  });
};

/**
 * Tag get
 * Get a tag with any connected spots
 */
export const getTag = <ThrowOnError extends boolean = false>(
  options: Options<GetTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTagResponses,
    GetTagErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}",
    ...options,
  });
};

/**
 * Tag update
 * Update a tag
 */
export const putTag = <ThrowOnError extends boolean = false>(
  options: Options<PutTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    PutTagResponses,
    PutTagErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Tag get entrances
 * Get all entrances connected to a Tag
 */
export const getTagEntrances = <ThrowOnError extends boolean = false>(
  options: Options<GetTagEntrancesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTagEntrancesResponses,
    GetTagEntrancesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}/entrances",
    ...options,
  });
};

/**
 * Tag set entrances
 * Set entrances to connect to a Tag
 */
export const setTagEntrances = <ThrowOnError extends boolean = false>(
  options: Options<SetTagEntrancesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetTagEntrancesResponses,
    SetTagEntrancesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}/entrances",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Tag set terms
 * Get the terms of a tag
 */
export const getTagTerms = <ThrowOnError extends boolean = false>(
  options: Options<GetTagTermsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTagTermsResponses,
    GetTagTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}/terms",
    ...options,
  });
};

/**
 * Tag set terms
 * Set terms for a tag
 */
export const setTagTerms = <ThrowOnError extends boolean = false>(
  options: Options<SetTagTermsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetTagTermsResponses,
    SetTagTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/tags/{id}/terms",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Product get
 * Get a product by ID
 */
export const productGet = <ThrowOnError extends boolean = false>(
  options: Options<ProductGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ProductGetResponses,
    ProductGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/products/{id}",
    ...options,
  });
};

/**
 * Product put
 * Update a product by ID
 */
export const productPut = <ThrowOnError extends boolean = false>(
  options: Options<ProductPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ProductPutResponses,
    ProductPutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/products/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Products search
 * Paginated search of products
 */
export const productsSearch = <ThrowOnError extends boolean = false>(
  options: Options<ProductsSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ProductsSearchResponses,
    ProductsSearchErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/products/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Products delete
 * Delete multiple products
 */
export const productsDelete = <ThrowOnError extends boolean = false>(
  options: Options<ProductsDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    ProductsDeleteResponses,
    ProductsDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/products/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Product create
 * Create a product
 */
export const productCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProductCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ProductCreateResponses,
    ProductCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor search
 * Paginated search of debtors
 */
export const debtorSearch = <ThrowOnError extends boolean = false>(
  options: Options<DebtorSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorSearchResponses,
    DebtorSearchErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor batch delete
 * Batch delete debtors
 */
export const debtorBatchDelete = <ThrowOnError extends boolean = false>(
  options: Options<DebtorBatchDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DebtorBatchDeleteResponses,
    DebtorBatchDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor create
 * Create a new debtor
 */
export const debtorCreate = <ThrowOnError extends boolean = false>(
  options: Options<DebtorCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorCreateResponses,
    DebtorCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor delete
 * Delete a debtor by id
 */
export const debtorDelete = <ThrowOnError extends boolean = false>(
  options: Options<DebtorDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DebtorDeleteResponses,
    DebtorDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}",
    ...options,
  });
};

/**
 * Debtor get
 * Get a debtor by id
 */
export const debtorGet = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetResponses,
    DebtorGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}",
    ...options,
  });
};

/**
 * Debtor update
 * Update a debtor by id
 */
export const debtorPut = <ThrowOnError extends boolean = false>(
  options: Options<DebtorPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    DebtorPutResponses,
    DebtorPutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get cards
 * Get cards for Debtor
 */
export const debtorGetCards = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetCardsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetCardsResponses,
    DebtorGetCardsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/cards",
    ...options,
  });
};

/**
 * Debtor setup new Payment card
 * Setup a new card for a Debtor
 */
export const debtorSetupCard = <ThrowOnError extends boolean = false>(
  options: Options<DebtorSetupCardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorSetupCardResponses,
    DebtorSetupCardErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/cards",
    ...options,
  });
};

/**
 * Debtor delete card
 * Deleta a payment card for a debtor
 */
export const debtorDeleteCard = <ThrowOnError extends boolean = false>(
  options: Options<DebtorDeleteCardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorDeleteCardResponses,
    DebtorDeleteCardErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{debtorId}/cards/{cardId}",
    ...options,
  });
};

/**
 * Debtor set default
 * Debtor set default payment card
 */
export const debtorSetDefaultCard = <ThrowOnError extends boolean = false>(
  options: Options<DebtorSetDefaultCardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    DebtorSetDefaultCardResponses,
    DebtorSetDefaultCardErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{debtorId}/cards/{cardId}",
    ...options,
  });
};

/**
 * Debtor finalize card setup
 * Finalize card setup for a debtor
 */
export const debtorFinalizeCardSetup = <ThrowOnError extends boolean = false>(
  options: Options<DebtorFinalizeCardSetupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorFinalizeCardSetupResponses,
    DebtorFinalizeCardSetupErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{debtorId}/cards/setup/{setupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get delivery method
 * Get delivery method for Debtor
 */
export const debtorGetDeliveryMethod = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetDeliveryMethodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetDeliveryMethodResponses,
    DebtorGetDeliveryMethodErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/delivery_method",
    ...options,
  });
};

/**
 * Debtor set delivery method
 * Set delivery method for Debtor
 */
export const debtorSetDeliveryMethod = <ThrowOnError extends boolean = false>(
  options: Options<DebtorSetDeliveryMethodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    DebtorSetDeliveryMethodResponses,
    DebtorSetDeliveryMethodErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/delivery_method",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get payment method
 * Get payment method for Debtor
 */
export const debtorGetPaymentMethod = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetPaymentMethodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetPaymentMethodResponses,
    DebtorGetPaymentMethodErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/payment_method",
    ...options,
  });
};

/**
 * Debtor set payment method
 * Set payment method for Debtor
 */
export const debtorSetPaymentMethod = <ThrowOnError extends boolean = false>(
  options: Options<DebtorSetPaymentMethodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    DebtorSetPaymentMethodResponses,
    DebtorSetPaymentMethodErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/payment_method",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get agreements
 * Get all agreements for a debtor
 */
export const debtorGetAgreements = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetAgreementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetAgreementsResponses,
    DebtorGetAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/agreements",
    ...options,
  });
};

/**
 * Debtor remove users
 * Remove users with access to a debtor
 */
export const debtorRemoveUsers = <ThrowOnError extends boolean = false>(
  options: Options<DebtorRemoveUsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DebtorRemoveUsersResponses,
    DebtorRemoveUsersErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get users
 * Get users with access to a debtor
 */
export const debtorGetUsers = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetUsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetUsersResponses,
    DebtorGetUsersErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/users",
    ...options,
  });
};

/**
 * Debtor add user
 * Add or update user access to debtor
 */
export const debtorAddUser = <ThrowOnError extends boolean = false>(
  options: Options<DebtorAddUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorAddUserResponses,
    DebtorAddUserErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Resend user invite
 * Send the user invite email again
 */
export const resendUserInvite = <ThrowOnError extends boolean = false>(
  options: Options<ResendUserInviteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ResendUserInviteResponses,
    ResendUserInviteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/resend_user_invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Debtor get applicants
 * Get all applicants for Debtor
 */
export const debtorGetApplicants = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetApplicantsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetApplicantsResponses,
    DebtorGetApplicantsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/applicants",
    ...options,
  });
};

/**
 * Debtor get invoices
 * Get invoices created for this Debtor
 */
export const debtorGetInvoices = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetInvoicesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetInvoicesResponses,
    DebtorGetInvoicesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/invoices",
    ...options,
  });
};

/**
 * Debtor get invoice PDF
 * Gets an Invoice for a Debtor as PDF
 */
export const debtorGetInvoicePdf = <ThrowOnError extends boolean = false>(
  options: Options<DebtorGetInvoicePdfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DebtorGetInvoicePdfResponses,
    DebtorGetInvoicePdfErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{debtorId}/invoices/{invoiceId}/pdf",
    ...options,
  });
};

/**
 * Request the debtor to fill in a payment card
 * An email will be sent to the debtor
 */
export const debtorRequestPaymentCard = <ThrowOnError extends boolean = false>(
  options: Options<DebtorRequestPaymentCardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorRequestPaymentCardResponses,
    DebtorRequestPaymentCardErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/request-payment-card",
    ...options,
  });
};

/**
 * List debtor payments
 * List debtor payments
 */
export const debtorListPayments = <ThrowOnError extends boolean = false>(
  options: Options<DebtorListPaymentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorListPaymentsResponses,
    DebtorListPaymentsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{id}/payments/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Send Receipt for a Payment
 * Send payment receipt
 */
export const debtorSendPaymentReceipt = <ThrowOnError extends boolean = false>(
  options: Options<DebtorSendPaymentReceiptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorSendPaymentReceiptResponses,
    DebtorSendPaymentReceiptErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{debtor_id}/payments/{payment_id}/receipt",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Refund payment
 * Refund payment
 */
export const debtorRefundPayment = <ThrowOnError extends boolean = false>(
  options: Options<DebtorRefundPaymentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DebtorRefundPaymentResponses,
    DebtorRefundPaymentErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/debtors/{debtor_id}/payments/{payment_id}/refund",
    ...options,
  });
};

/**
 * Agreement create
 * Create a new agreement
 */
export const createAgreement = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgreementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgreementResponses,
    CreateAgreementErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreement search
 * Searches for agreements
 */
export const searchAgreements = <ThrowOnError extends boolean = false>(
  options: Options<SearchAgreementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchAgreementsResponses,
    SearchAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreements Pre Approve
 * Pre approve multiple agreements
 */
export const preApproveAgreements = <ThrowOnError extends boolean = false>(
  options: Options<PreApproveAgreementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PreApproveAgreementsResponses,
    PreApproveAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/preapprove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreements Reset to Draft
 * Reset multiple agreements to Draft
 */
export const resetAgreementsToDraft = <ThrowOnError extends boolean = false>(
  options: Options<ResetAgreementsToDraftData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ResetAgreementsToDraftResponses,
    ResetAgreementsToDraftErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/reset-to-draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreement offer to debtor
 * Offer an agreement to a debtor
 */
export const offerAgreement = <ThrowOnError extends boolean = false>(
  options: Options<OfferAgreementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OfferAgreementResponses,
    OfferAgreementErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/offer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreements end
 * Set the end date of multiple agreements
 */
export const endAgreements = <ThrowOnError extends boolean = false>(
  options: Options<EndAgreementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EndAgreementsResponses,
    EndAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/end",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreements delete
 * Delete multiple agreements
 */
export const deleteAgreements = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgreementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DeleteAgreementsResponses,
    DeleteAgreementsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreement get
 * Get an agreement
 */
export const getAgreement = <ThrowOnError extends boolean = false>(
  options: Options<GetAgreementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgreementResponses,
    GetAgreementErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}",
    ...options,
  });
};

/**
 * Agreement update
 * Update an agreement draft
 */
export const updateAgreement = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgreementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAgreementResponses,
    UpdateAgreementErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreement get Shares
 * Get all shares via this agreement
 */
export const getAgreementShares = <ThrowOnError extends boolean = false>(
  options: Options<GetAgreementSharesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgreementSharesResponses,
    GetAgreementSharesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/shares",
    ...options,
  });
};

/**
 * Agreement get Pdf
 * Download the agreement as a Pdf
 */
export const getAgreementPdf = <ThrowOnError extends boolean = false>(
  options: Options<GetAgreementPdfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgreementPdfResponses,
    GetAgreementPdfErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/pdf",
    ...options,
  });
};

/**
 * Agreement set Pdf
 * Upload a new PDF for this agreement
 */
export const setAgreementPdf = <ThrowOnError extends boolean = false>(
  options: Options<SetAgreementPdfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetAgreementPdfResponses,
    SetAgreementPdfErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/pdf",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreement get additional Terms
 * Get the additional terms of an agreement
 */
export const getAgreementAdditionalTerms = <
  ThrowOnError extends boolean = false,
>(options: Options<GetAgreementAdditionalTermsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<
    GetAgreementAdditionalTermsResponses,
    GetAgreementAdditionalTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/additional_terms",
    ...options,
  });
};

/**
 * Agreement set additional Terms
 * Set additional terms for an agreement
 */
export const setAgreementAdditionalTerms = <
  ThrowOnError extends boolean = false,
>(options: Options<SetAgreementAdditionalTermsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<
    SetAgreementAdditionalTermsResponses,
    SetAgreementAdditionalTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/additional_terms",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Agreement get full Terms
 * Get the full terms for an agreement. Site terms + tag terms + agreement terms
 */
export const getAgreementFullTerms = <ThrowOnError extends boolean = false>(
  options: Options<GetAgreementFullTermsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgreementFullTermsResponses,
    GetAgreementFullTermsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/full_terms",
    ...options,
  });
};

/**
 * Agreement reply to Offer
 * Reply to an offered Agreement
 */
export const replyToAgreementOffer = <ThrowOnError extends boolean = false>(
  options: Options<ReplyToAgreementOfferData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ReplyToAgreementOfferResponses,
    ReplyToAgreementOfferErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/agreements/{id}/offer/reply",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Park46 search Debtors
 * Search debtors in Par46
 */
export const park46SearchDebtors = <ThrowOnError extends boolean = false>(
  options: Options<Park46SearchDebtorsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    Park46SearchDebtorsResponses,
    Park46SearchDebtorsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/park46/debtors",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Park46 search Sites
 * Search sites in Par46
 */
export const park46SearchSites = <ThrowOnError extends boolean = false>(
  options: Options<Park46SearchSitesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    Park46SearchSitesResponses,
    Park46SearchSitesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/park46/sites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Device create
 * Creates a new Device
 */
export const createDevice = <ThrowOnError extends boolean = false>(
  options: Options<CreateDeviceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateDeviceResponses,
    CreateDeviceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/devices",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Device delete many
 * Deletes multiple devices
 */
export const deleteDevices = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDevicesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteDevicesResponses,
    DeleteDevicesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/devices/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Device get
 * Get a device with by id
 */
export const getDevice = <ThrowOnError extends boolean = false>(
  options: Options<GetDeviceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDeviceResponses,
    GetDeviceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/devices/{id}",
    ...options,
  });
};

/**
 * Device update
 * Update a device
 */
export const putDevice = <ThrowOnError extends boolean = false>(
  options: Options<PutDeviceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    PutDeviceResponses,
    PutDeviceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/devices/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Device actuate
 * Actuate a remote device with device id
 */
export const actuateDevice = <ThrowOnError extends boolean = false>(
  options: Options<ActuateDeviceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ActuateDeviceResponses,
    ActuateDeviceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/devices/{id}/actuate",
    ...options,
  });
};

/**
 * Entrace create
 * Creates a new Entrance
 */
export const createEntrance = <ThrowOnError extends boolean = false>(
  options: Options<CreateEntranceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateEntranceResponses,
    CreateEntranceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Entrace search
 * Search entrances
 */
export const searchEntrance = <ThrowOnError extends boolean = false>(
  options: Options<SearchEntranceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchEntranceResponses,
    SearchEntranceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Entrance delete
 * Deletes an entrance by id
 */
export const deleteEntrance = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEntranceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteEntranceResponses,
    DeleteEntranceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}",
    ...options,
  });
};

/**
 * Entrance get
 * Get an entrance by id
 */
export const getEntrance = <ThrowOnError extends boolean = false>(
  options: Options<GetEntranceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntranceResponses,
    GetEntranceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}",
    ...options,
  });
};

/**
 * Entrance update
 * Update an entrance
 */
export const putEntrance = <ThrowOnError extends boolean = false>(
  options: Options<PutEntranceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    PutEntranceResponses,
    PutEntranceErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Entrance get tags
 * Get all tags connected to a entrance
 */
export const getEntranceTags = <ThrowOnError extends boolean = false>(
  options: Options<GetEntranceTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntranceTagsResponses,
    GetEntranceTagsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}/tags",
    ...options,
  });
};

/**
 * Entrance set tags
 * Set tags connected to entrance
 */
export const setEntranceTags = <ThrowOnError extends boolean = false>(
  options: Options<SetEntranceTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetEntranceTagsResponses,
    SetEntranceTagsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Entrance get devices
 * Get all devices connected to a entrance
 */
export const getEntranceDevices = <ThrowOnError extends boolean = false>(
  options: Options<GetEntranceDevicesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntranceDevicesResponses,
    GetEntranceDevicesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}/devices",
    ...options,
  });
};

/**
 * Entrance set devices
 * Set devices connected to entrance
 */
export const setEntranceDevices = <ThrowOnError extends boolean = false>(
  options: Options<SetEntranceDevicesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SetEntranceDevicesResponses,
    SetEntranceDevicesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/entrances/{id}/devices",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * SpotShare search
 * Search all spot shares
 */
export const searchSpotShares = <ThrowOnError extends boolean = false>(
  options: Options<SearchSpotSharesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchSpotSharesResponses,
    SearchSpotSharesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_shares/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * SpotShare accept
 * Accept a Shared spot
 */
export const acceptSpotShare = <ThrowOnError extends boolean = false>(
  options: Options<AcceptSpotShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AcceptSpotShareResponses,
    AcceptSpotShareErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_shares/{id}/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * SpotShare delete
 * Deletes a previously shared Spot
 */
export const deleteSpotShare = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSpotShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteSpotShareResponses,
    DeleteSpotShareErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_shares/{id}",
    ...options,
  });
};

/**
 * SpotShare Get
 * Get a SpotShare
 */
export const getSpotShare = <ThrowOnError extends boolean = false>(
  options: Options<GetSpotShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpotShareResponses,
    GetSpotShareErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_shares/{id}",
    ...options,
  });
};

/**
 * SpotShare update
 * Update a tag
 */
export const updateSpotShare = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSpotShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSpotShareResponses,
    UpdateSpotShareErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_shares/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * SpotShare Create
 * Create a new spot share
 */
export const createSpotShare = <ThrowOnError extends boolean = false>(
  options: Options<CreateSpotShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateSpotShareResponses,
    CreateSpotShareErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_shares",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue get
 * Get a queue
 */
export const queueGet = <ThrowOnError extends boolean = false>(
  options: Options<QueueGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    QueueGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/queues/{id}",
    ...options,
  });
};

/**
 * Queue update
 * Queue Update
 */
export const queuePut = <ThrowOnError extends boolean = false>(
  options: Options<QueuePutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    QueuePutResponses,
    QueuePutErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue get Availability
 * Get availability given a list of selected tags
 */
export const queueGetAvailability = <ThrowOnError extends boolean = false>(
  options: Options<QueueGetAvailabilityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    QueueGetAvailabilityResponses,
    QueueGetAvailabilityErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}/availability",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue search Spots
 * Search spots in queue
 */
export const queueSearchSpots = <ThrowOnError extends boolean = false>(
  options: Options<QueueSearchSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    QueueSearchSpotsResponses,
    QueueSearchSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}/spots",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * QueueStep Create
 * Create a new Queue Step
 */
export const queueStepCreate = <ThrowOnError extends boolean = false>(
  options: Options<QueueStepCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    QueueStepCreateResponses,
    QueueStepCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}/steps",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * QueueStep Delete
 * Delete a Queue Step
 */
export const queueStepDelete = <ThrowOnError extends boolean = false>(
  options: Options<QueueStepDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    QueueStepDeleteResponses,
    QueueStepDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{queueId}/steps/{stepId}",
    ...options,
  });
};

/**
 * QueueStep Update
 * Update a Queue Step
 */
export const queueStepUpdate = <ThrowOnError extends boolean = false>(
  options: Options<QueueStepUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    QueueStepUpdateResponses,
    QueueStepUpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{queueId}/steps/{stepId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue Step Set tags
 * Set tags associatied to a queue step
 */
export const queueStepSetTags = <ThrowOnError extends boolean = false>(
  options: Options<QueueStepSetTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    QueueStepSetTagsResponses,
    QueueStepSetTagsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{queueId}/steps/{stepId}/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue delete multiple Applicants
 * Delete multiple applicants from the queue
 */
export const queueBulkDeleteApplicants = <ThrowOnError extends boolean = false>(
  options: Options<QueueBulkDeleteApplicantsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    QueueBulkDeleteApplicantsResponses,
    QueueBulkDeleteApplicantsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}/applicants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue get Applicants
 * Get all applicants for a queue
 */
export const queueGetApplicants = <ThrowOnError extends boolean = false>(
  options: Options<QueueGetApplicantsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    QueueGetApplicantsResponses,
    QueueGetApplicantsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}/applicants",
    ...options,
  });
};

/**
 * Queue add Applicant
 * Add an Applicant to a queue
 */
export const queuePostApplicant = <ThrowOnError extends boolean = false>(
  options: Options<QueuePostApplicantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    QueuePostApplicantResponses,
    QueuePostApplicantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/{id}/applicants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue remove Applicant
 * Remove an Applicant from a queue
 */
export const queueDeleteApplicant = <ThrowOnError extends boolean = false>(
  options: Options<QueueDeleteApplicantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    QueueDeleteApplicantResponses,
    QueueDeleteApplicantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/applicants/{id}",
    ...options,
  });
};

/**
 * Queue get an Applicant
 * Get an Applicant in a queue
 */
export const queueGetApplicant = <ThrowOnError extends boolean = false>(
  options: Options<QueueGetApplicantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    QueueGetApplicantResponses,
    QueueGetApplicantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/applicants/{id}",
    ...options,
  });
};

/**
 * Queue update an Applicant
 * Update an Applicant in a queue
 */
export const queueUpdateApplicant = <ThrowOnError extends boolean = false>(
  options: Options<QueueUpdateApplicantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    QueueUpdateApplicantResponses,
    QueueUpdateApplicantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/applicants/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue Applicant get matching spots
 * Get matching spots for an applicant
 */
export const queueApplicantMatchingSpots = <
  ThrowOnError extends boolean = false,
>(options: Options<QueueApplicantMatchingSpotsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<
    QueueApplicantMatchingSpotsResponses,
    QueueApplicantMatchingSpotsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/applicants/{id}/matching_spots",
    ...options,
  });
};

/**
 * Queue Applicant set debtor id
 * Sets the debtor of the applicant. The account must have admin rights for the debtor.
 */
export const applicantSetDebtor = <ThrowOnError extends boolean = false>(
  options: Options<ApplicantSetDebtorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ApplicantSetDebtorResponses,
    ApplicantSetDebtorErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/applicants/{id}/debtor",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Queue Applicants send info requests
 * Send info requests to the provided applicants
 */
export const queueApplicantsInfoRequest = <
  ThrowOnError extends boolean = false,
>(options: Options<QueueApplicantsInfoRequestData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<
    QueueApplicantsInfoRequestResponses,
    QueueApplicantsInfoRequestErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/queues/applicants/send-info-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Creditors get all
 * Get all creditors, including from Billecta
 */
export const getAllCreditors = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllCreditorsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllCreditorsResponses,
    GetAllCreditorsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/creditors/all",
    ...options,
  });
};

/**
 * Creditor get
 * Get a creditor by id
 */
export const getCreditor = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCreditorResponses,
    GetCreditorErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/creditors/{id}",
    ...options,
  });
};

/**
 * Creditor update
 * Update the creditor with the given ID and data
 */
export const updateCreditor = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCreditorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateCreditorResponses,
    UpdateCreditorErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/creditors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * SelfInvoicing get all commissions on products for the given site
 * configures commission on the given product
 */
export const siGetProductCommissions = <ThrowOnError extends boolean = false>(
  options: Options<SiGetProductCommissionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SiGetProductCommissionsResponses,
    SiGetProductCommissionsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/self-invoicing/{id}/commissions",
    ...options,
  });
};

/**
 * SelfInvoicing set commission on product
 * configures commission on the given product
 */
export const siPutProductCommission = <ThrowOnError extends boolean = false>(
  options: Options<SiPutProductCommissionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SiPutProductCommissionResponses,
    SiPutProductCommissionErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/self-invoicing/{id}/commissions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * DPLite user search
 * Search of DPLite users
 */
export const dpliteUserSearch = <ThrowOnError extends boolean = false>(
  options: Options<DpliteUserSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DpliteUserSearchResponses,
    DpliteUserSearchErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/dplite/users/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * DPLite user create
 * Create a DPLite user
 */
export const dpliteUserCreate = <ThrowOnError extends boolean = false>(
  options: Options<DpliteUserCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DpliteUserCreateResponses,
    DpliteUserCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/dplite/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * DPLite user set access
 * Set password of a user
 */
export const dpliteUserSetAccess = <ThrowOnError extends boolean = false>(
  options: Options<DpliteUserSetAccessData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    DpliteUserSetAccessResponses,
    DpliteUserSetAccessErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/dplite/users/{id}/access",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * DPLite user set password
 * Set password of a user
 */
export const dpliteUserSetPassword = <ThrowOnError extends boolean = false>(
  options: Options<DpliteUserSetPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    DpliteUserSetPasswordResponses,
    DpliteUserSetPasswordErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/dplite/users/{id}/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * DPLite user delete
 * Delete a DpLiteUser
 */
export const dpliteUserDelete = <ThrowOnError extends boolean = false>(
  options: Options<DpliteUserDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DpliteUserDeleteResponses,
    DpliteUserDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/dplite/users/{id}",
    ...options,
  });
};

/**
 * DPLite user get
 * Get a DpLiteUser
 */
export const dpliteUserGet = <ThrowOnError extends boolean = false>(
  options: Options<DpliteUserGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DpliteUserGetResponses,
    DpliteUserGetErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/dplite/users/{id}",
    ...options,
  });
};

/**
 * Create a new agreement with a permit attached to it
 */
export const createPermit = <ThrowOnError extends boolean = false>(
  options: Options<CreatePermitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePermitResponses,
    CreatePermitErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete the permit agreement
 */
export const deletePermitAgreement = <ThrowOnError extends boolean = false>(
  options: Options<DeletePermitAgreementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DeletePermitAgreementResponses,
    DeletePermitAgreementErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/agreement/{agreement_id}",
    ...options,
  });
};

/**
 * Preview payment for Permit
 * Permit Preview payment
 */
export const previewPayPermit = <ThrowOnError extends boolean = false>(
  options: Options<PreviewPayPermitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PreviewPayPermitResponses,
    PreviewPayPermitErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/agreement/{agreement_id}/pay",
    ...options,
  });
};

/**
 * Pay for permit and activate it
 * Permit pay
 */
export const payPermit = <ThrowOnError extends boolean = false>(
  options: Options<PayPermitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PayPermitResponses,
    PayPermitErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/agreement/{agreement_id}/pay",
    ...options,
  });
};

/**
 * Preview payment for Permit period
 * Permit Preview payment for period
 */
export const previewPayPermitPeriod = <ThrowOnError extends boolean = false>(
  options: Options<PreviewPayPermitPeriodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PreviewPayPermitPeriodResponses,
    PreviewPayPermitPeriodErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/agreement/{agreement_id}/pay-period/{period}",
    ...options,
  });
};

/**
 * Pay for permit period
 * Will not do anything to the agreement. Will not send email with receipt. Will only perform the payment and create an invoice.
 */
export const payPermitPeriod = <ThrowOnError extends boolean = false>(
  options: Options<PayPermitPeriodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PayPermitPeriodResponses,
    PayPermitPeriodErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/agreement/{agreement_id}/pay-period/{period}",
    ...options,
  });
};

export const permitBulkDeleteGrant = <ThrowOnError extends boolean = false>(
  options: Options<PermitBulkDeleteGrantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    PermitBulkDeleteGrantResponses,
    PermitBulkDeleteGrantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/{permit_id}/grant",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create permit grant
 */
export const permitCreateGrant = <ThrowOnError extends boolean = false>(
  options: Options<PermitCreateGrantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PermitCreateGrantResponses,
    PermitCreateGrantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/{permit_id}/grant",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Retreives a grant
 */
export const permitGetGrant = <ThrowOnError extends boolean = false>(
  options: Options<PermitGetGrantData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PermitGetGrantResponses,
    PermitGetGrantErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/grant/{grant_id}",
    ...options,
  });
};

/**
 * Search grants
 */
export const searchGrants = <ThrowOnError extends boolean = false>(
  options: Options<SearchGrantsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchGrantsResponses,
    SearchGrantsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/grant/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Retreives a grant
 */
export const updateGrantLicensePlate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGrantLicensePlateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateGrantLicensePlateResponses,
    UpdateGrantLicensePlateErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/grant/{grant_id}/license_plate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Stop permit session
 */
export const permitSessionStop = <ThrowOnError extends boolean = false>(
  options: Options<PermitSessionStopData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    PermitSessionStopResponses,
    PermitSessionStopErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/grant/{grant_id}/session",
    ...options,
  });
};

/**
 * Start permit session
 */
export const permitSessionStart = <ThrowOnError extends boolean = false>(
  options: Options<PermitSessionStartData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PermitSessionStartResponses,
    PermitSessionStartErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/grant/{grant_id}/session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List all sessions for a permit
 */
export const permitListSessions = <ThrowOnError extends boolean = false>(
  options: Options<PermitListSessionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PermitListSessionsResponses,
    PermitListSessionsErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/permits/session/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Search for spot classes
 */
export const searchSpotClasses = <ThrowOnError extends boolean = false>(
  options: Options<SearchSpotClassesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchSpotClassesResponses,
    SearchSpotClassesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/spot_classes/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get spots within a spotclass
 */
export const spotclassGetSpots = <ThrowOnError extends boolean = false>(
  options: Options<SpotclassGetSpotsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SpotclassGetSpotsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/spot_classes/spots",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodeSeries Search
 * Search for AccessCodeSeries
 */
export const searchAccessCodeSeries = <ThrowOnError extends boolean = false>(
  options: Options<SearchAccessCodeSeriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchAccessCodeSeriesResponses,
    SearchAccessCodeSeriesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodeSeries Create
 * Create AccessCode series
 */
export const createAccessCodeSeries = <ThrowOnError extends boolean = false>(
  options: Options<CreateAccessCodeSeriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAccessCodeSeriesResponses,
    CreateAccessCodeSeriesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodeSeries Delete
 * Deletes an AccessCodeSeries
 */
export const deleteAccessCodeSeries = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAccessCodeSeriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAccessCodeSeriesResponses,
    DeleteAccessCodeSeriesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series/{id}",
    ...options,
  });
};

/**
 * AccessCodeSeries Get
 * Get an AccessCodeSeries
 */
export const getAccessCodeSeries = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessCodeSeriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccessCodeSeriesResponses,
    GetAccessCodeSeriesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series/{id}",
    ...options,
  });
};

/**
 * AccessCodeSeries connected series
 * AccessCodeSeries connect series
 */
export const postAccessCodeSeriesConnectedSeries = <
  ThrowOnError extends boolean = false,
>(options: Options<PostAccessCodeSeriesConnectedSeriesData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<
    PostAccessCodeSeriesConnectedSeriesResponses,
    PostAccessCodeSeriesConnectedSeriesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodeSeries update
 * Updates an AccessCodeSeries
 */
export const updateAccessCodeSeries = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAccessCodeSeriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAccessCodeSeriesResponses,
    UpdateAccessCodeSeriesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodeSeries set Sites
 * Sets the sites connected to an AccessCodeSeries
 */
export const accessCodeSeriesSetSites = <ThrowOnError extends boolean = false>(
  options: Options<AccessCodeSeriesSetSitesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AccessCodeSeriesSetSitesResponses,
    AccessCodeSeriesSetSitesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_code_series/{id}/sites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCode Search
 * Search for AccessCodes
 */
export const searchAccessCodes = <ThrowOnError extends boolean = false>(
  options: Options<SearchAccessCodesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SearchAccessCodesResponses,
    SearchAccessCodesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_codes/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodes create
 * Create AccessCodes in bulk
 */
export const bulkCreateAccessCodes = <ThrowOnError extends boolean = false>(
  options: Options<BulkCreateAccessCodesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BulkCreateAccessCodesResponses,
    BulkCreateAccessCodesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_codes/create",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodes update
 * Update AccessCodes in bulk
 */
export const bulkUpdateAccessCodes = <ThrowOnError extends boolean = false>(
  options: Options<BulkUpdateAccessCodesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BulkUpdateAccessCodesResponses,
    BulkUpdateAccessCodesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_codes/update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AccessCodes delete
 * Delete AccessCodes in bulk
 */
export const bulkDeleteAccessCodes = <ThrowOnError extends boolean = false>(
  options: Options<BulkDeleteAccessCodesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BulkDeleteAccessCodesResponses,
    BulkDeleteAccessCodesErrors,
    ThrowOnError
  >({
    security: [
      {
        name: "X-Authorization",
        type: "apiKey",
      },
    ],
    url: "/access_codes/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getCounter = <ThrowOnError extends boolean = false>(
  options?: Options<GetCounterData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCounterResponses,
    unknown,
    ThrowOnError
  >({
    url: "/counter",
    ...options,
  });
};
